export const useCacheStore = defineStore("cacheMemory", () => {
  // interface
  interface Docket {
    PAGE: number;
    ITEM_PER_PAGE: number;
    STATUS: string[] | null;
    SEARCH: string | undefined;
  }

  interface User {
    PAGE: number;
    ITEM_PER_PAGE: number;
    SEARCH: string | undefined;
  }

  interface Staff {
    PAGE: number;
    ITEM_PER_PAGE: number;
    SEARCH: string | undefined;
  }
  interface Event {
    PAGE: number;
    ITEM_PER_PAGE: number;
    SEARCH: string | undefined;
  }

  interface Cache {
    DOCKET: Docket;
    USER: User;
    STAFF_HOUR: Staff;
    STAFF_LOG: Staff;
    EVENT: Event;
  }

  // Data
  const cacheData = ref<Cache>({
    DOCKET: {
      PAGE: 1,
      ITEM_PER_PAGE: 10,
      STATUS: null,
      SEARCH: "",
    },
    USER: {
      PAGE: 1,
      ITEM_PER_PAGE: 10,
      SEARCH: "",
    },
    STAFF_HOUR: {
      PAGE: 1,
      ITEM_PER_PAGE: 10,
      SEARCH: "",
    },
    STAFF_LOG: {
      PAGE: 1,
      ITEM_PER_PAGE: 10,
      SEARCH: "",
    },
    EVENT: {
      PAGE: 1,
      ITEM_PER_PAGE: 10,
      SEARCH: "",
    },
  }) as any;

  const dummyData = {
    DOCKET: {
      PAGE: 1,
      ITEM_PER_PAGE: 10,
      STATUS: null,
      SEARCH: "",
    },
    USER: {
      PAGE: 1,
      ITEM_PER_PAGE: 10,
      SEARCH: "",
    },
    STAFF_HOUR: {
      PAGE: 1,
      ITEM_PER_PAGE: 10,
      SEARCH: "",
    },
    STAFF_LOG: {
      PAGE: 1,
      ITEM_PER_PAGE: 10,
      SEARCH: "",
    },
    EVENT: {
      PAGE: 1,
      ITEM_PER_PAGE: 10,
      SEARCH: "",
    },
  };

  // methods
  const fetchCacheMemory = async () => {
    cacheData.value = JSON.parse(
      localStorage.getItem("cacheMemory") || JSON.stringify(dummyData)
    );
    return await cacheData.value;
  };

  const updateCacheMemory = (
    name: string,
    key: string,
    val: string | number | undefined
  ) => {
    // Initialize it if not present
    if (!cacheData.value[name]) {
      cacheData.value[name] = {};
    }

    cacheData.value[name][key] = val as any;
    localStorage.setItem("cacheMemory", JSON.stringify(cacheData.value));
  };

  onMounted(() => {
    fetchCacheMemory();
  });

  return { cacheData, fetchCacheMemory, updateCacheMemory };
});
